"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Mist_1 = require("./Mist");
var MistThreaded_1 = require("./MistThreaded");
var MistFactory = function (config, files) {
    if (config === void 0) { config = {}; }
    if (files === void 0) { files = []; }
    return config.worker ? new MistThreaded_1.default(config, files) : new Mist_1.default(config, files);
};
exports.default = MistFactory;
